/** @format */

export const SHIPPING_MESSAGES = {
  OutOfStock: {
    text: 'Not Available to Ship',
    icon: 'sign-circled-cancel-fill',
    class: 'red',
  },
  LowStock: {
    text: 'Limited Stock to Ship',
    icon: 'sign-circled-check-fill',
    class: 'yellow',
  },
  InStock: {
    text: 'Shipping Available',
    icon: 'sign-circled-check-fill',
    class: 'green',
  },
};

export const PICKUP_MESSAGES = {
  OutOfStock: {
    text: 'Not Available to Pickup',
    icon: 'sign-circled-cancel-fill',
    class: 'red',
  },
  LowStock: {
    text: 'Limited Stock to Pickup',
    icon: 'sign-circled-check-fill',
    class: 'yellow',
  },
  AvailableNearBy: {
    text: 'In Nearby Stores',
    icon: 'sign-circled-check-fill',
    class: 'yellow',
  },
  InStock: {
    text: 'Free Pickup Available',
    icon: 'sign-circled-check-fill',
    class: 'green',
  },
  ShipToStore: {
    text: 'Free Ship to Store',
    icon: 'sign-circled-check-fill',
    class: 'green',
  },
};
